import { render, staticRenderFns } from "./PortalAdmin.vue?vue&type=template&id=7df4a775&scoped=true&"
import script from "./PortalAdmin.vue?vue&type=script&lang=js&"
export * from "./PortalAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PortalAdmin.vue?vue&type=style&index=0&id=7df4a775&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df4a775",
  null
  
)

export default component.exports